export default __webpack_public_path__ + "static/media/GreiffPremiumCf.bc4d7aea.jpeg";